<template>
  <div>
    <div class="row" v-if="showDiscount">
      <b class="col">Subtotal: </b>
      <b class="col-auto"> {{ currency }} {{ subtotal }} </b>
    </div>
    <div class="row" v-if="showDiscount">
      <b class="col">Descuentos: </b>
      <b class="col-auto"> {{ currency }} {{ totalDiscount }} </b>
    </div>
    <div class="row">
      <b class="col">Total a pagar: </b>
      <b class="col-auto text-action"> {{ currency }} {{ total }} </b>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    tickets: {
      type: Object,
      default: () => { }
    },
    currency: {
      type: String,
      default: 'S/'
    },
    validatedCuopons: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      totalDiscount: 0,
      totalDiscountByEvent: '',
      currentActivityId: ''
    };
  },
  watch: {
    setValidatedCuopons(value) {
      if (value.length > 0) {
        this.getTotalDiscount(this.setTickets, value);
      } else {
        this.totalDiscount = 0;
      }
    },
    totalDiscount(value) {
      const data = {
        subtotal: this.subtotal,
        discount: value,
        total: this.total,
      }
      this.$emit('totalsByEvent', data);
    },
    setTickets: {
      handler(value) {
        if (value) {
          this.getTotalDiscount(value, this.setValidatedCuopons);
        }
      },
      deep: true
    }
  },
  computed: {
    setTickets() {
      return this.tickets;
    },
    setValidatedCuopons() {
      return this.validatedCuopons;
    },
    subtotal() {
      return this.getSubtotal(this.setTickets);
    },
    total() {
      return (this.subtotal - this.totalDiscount).toFixed(2);
    },
    showDiscount() {
      return this.setTickets.activityId === this.currentActivityId && this.totalDiscount !== 0
        ? true
        : false;
    }
  },
  methods: {
    getSubtotal(value) {
      if (value.types.length > 0) {
        const suma = value.types
          .map((el) => el.price * this.validateValueSubtotal(el.value))
          .reduce((a, b) => a + b, 0);
        return suma.toFixed(2);
      }
    },
    validateValueSubtotal(val) {
      if (typeof val === 'string') {
        return val.toString().split(',').length;
      } else {
        return val;
      }
    },
    getTotalDiscount(tickets, coupons) {
      if (tickets && coupons) {
        let arrayDiscount = [];
        coupons.forEach((item) => {
          tickets.types.forEach((elem) => {
            if (elem.ticketTypeId === item.ticketTypeId) {
              const quantity = elem.type === 'venue' ? elem.value.split(",").length : elem.value;
              const totalDiscountByEvent = {
                activityId: elem.activityId,
                adhId: elem.adhId,
                discount: this.getDiscount(elem.price, item, quantity)
              };
              arrayDiscount.push(totalDiscountByEvent);
            }
          });
        });
        if (arrayDiscount.length > 0) {
          const suma = arrayDiscount.map((item) => item.discount).reduce((a, b) => a + b, 0);
          this.totalDiscount = suma.toFixed(2);
          this.currentActivityId = arrayDiscount[0].activityId;
        }
      }
    },
    getDiscount(price, coupon, count) {
      if (coupon.type === 1) return ((price * coupon.discountValue) / 100) * count;
      return coupon.discountValue * count;
    }
  }
};
</script>
